<template>
    <div>
        <div class="inline _fill" v-for="(item, index) in data" :key="index">
            <div class="grid">{{ item.start }} &ndash; {{ item.end }}</div>
            <div class="grid">{{ item.cnt_booked }} / {{ item.cnt_all }}</div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['data']
    }
</script>